import { render, staticRenderFns } from "./StaticButton.vue?vue&type=template&id=c11644fe&"
import script from "./StaticButton.vue?vue&type=script&lang=js&"
export * from "./StaticButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports